import { useFormContext } from 'react-hook-form'
import { Label } from './label'
import type { ReactNode } from 'react'

interface FieldProps {
    name: string
    label?: ReactNode
    children: ReactNode
    required?: boolean
    className?: string
}

/** Form field wrapper that displays label + RHF validation errors.
 *  Hỗ trợ cả top-level (name="foo") lẫn nested path (name="items.0.new_lot_code"). */
export function Field({
    name,
    label,
    children,
    required,
    className,
}: FieldProps) {
    return (
        <div className={className ?? 'space-y-1.5'}>
            {label && (
                <Label htmlFor={name} required={required}>
                    {label}
                </Label>
            )}
            {children}
            <FieldError name={name} />
        </div>
    )
}

interface FieldErrorProps {
    name: string
    className?: string
}

/** Render RHF validation error message cho input tại path `name`.
 *  Dùng cạnh input hiện có (Input/Combobox/…) mà không cần wrap Label — hữu ích
 *  trong danh sách item nơi label & input đã render sẵn. Không render gì nếu
 *  không có lỗi. Path dạng "items.0.quantity" cũng hoạt động. */
export function FieldError({ name, className }: FieldErrorProps) {
    const { getFieldState, formState } = useFormContext()
    const { error } = getFieldState(name, formState)
    if (!error?.message) return null
    return (
        // data-field-error: form có thể tìm câu lỗi đầu tiên để cuộn tới (lỗi
        // của cả mảng / khối không có ô aria-invalid nào để focus).
        <p
            className={className ?? 'mt-1 text-xs text-destructive'}
            data-field-error
        >
            {error.message}
        </p>
    )
}
